import { useEffect, useState } from "react";
import { Images } from "../../Assets/Index";
import { buyTickets, getallTickets } from "../../ApiServices/Apifun";
import { useDispatch, useSelector } from "react-redux";
import { setRoomDetail } from "../../Store/B2bslice";

import { dispatchtoast, getLocalStorageItem } from "../../Utils";

import { Avatar, Button, Card, Carousel, Image, Input, Radio, Tag } from "antd";
import { GiModernCity, GiRoad } from "react-icons/gi";
import { RiMenuFold4Fill } from "react-icons/ri";
import { LiaCitySolid } from "react-icons/lia";
import { BsBuildings } from "react-icons/bs";
import { PiCity } from "react-icons/pi";
import { BiPlay, BiUser } from "react-icons/bi";
import { IoMenu } from "react-icons/io5";
import { IoClose } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import {
  MdHelpOutline,
  MdLanguage,
  MdShare,
  MdWarning,
  MdWhatsapp,
} from "react-icons/md";
import { FaEarthAsia, FaLanguage } from "react-icons/fa6";
import { useCommmonStore } from "../../Store/CommonReducer";
import { getProfile } from "../Profile/UserEndpoints";

const AllGame = () => {
  const { profileDetail, setProfileDetail } = useCommmonStore();

  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(false);
  const accessToken = getLocalStorageItem("accessToken");

  const UserProfile = () => {
    getProfile()
      .then((res) => {
        if (res.status) {
          setProfileDetail(res.data);
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    // GetRoomDetails();
    UserProfile();
  }, [searchTerm, page]);

  const menuItems = [
    {
      key: "1",
      icon: <BiUser />,
      label: "Profile",
      title: "Profile",
      onClick: () => {
        // setSelectedMenu("1");
        accessToken ? navigate("/profile") : navigate("/");
      },
    },
    {
      key: "2",
      icon: <MdShare />,
      label: "Share",
      title: "Share",
      onClick: () => {
        // setSelectedMenu("1");
        accessToken ? navigate("/share") : navigate("/");
      },
    },
    {
      key: "3",
      icon: <MdWarning />,
      label: "Disclaimer",
      title: "Disclaimer",
      onClick: () => {
        // setSelectedMenu("1");
        accessToken ? navigate("/disclaimer") : navigate("/");
      },
    },
    {
      key: "4",
      icon: <MdWhatsapp />,
      label: "WhatsApp Support",
      title: "WhatsApp Support",
      onClick: () => {
        accessToken
          ? window.open("https://web.whatsapp.com/", "_blank")
          : navigate("/");
      },
    },
    // {
    //   key: "5",
    //   icon: <MdHelpOutline />,
    //   label: "Call Helpline",
    //   title: "Call Helpline",
    //   // onClick: () => {
    //   //   // setSelectedMenu("1");
    //   //   navigate("/helpline");
    //   // },
    // },
    {
      key: "6",
      icon: <FaEarthAsia />,
      label: "Website",
      title: "Website",
      // onClick: () => {
      //   // setSelectedMenu("1");
      //   navigate("/website");
      // },
    },

    // {
    //   key: "7",
    //   icon: <FaLanguage />,
    //   label: "Change Language",
    //   title: "Change Language",
    //   children: [
    //     {
    //       key: "7-1",
    //       label: "English",
    //       // onClick: () => {
    //       //   navigate("/CabDetails");
    //       // },
    //     },
    //     {
    //       key: "7-2",
    //       label: "Hindi",
    //       // onClick: () => {
    //       //   navigate("/CabDetails");
    //       // },
    //     },
    //   ],
    // },
  ];
  const renderMenuItems = (items) => {
    return (
      <ul className="pl-2  space-y-2">
        <div className="demo-logo-vertical d-flex justify-content-center ">
          <div className="flex justify-center m-5 items-center ">
            <Avatar
              size={64}
              icon={<BiUser />}
              // icon={
              //   <Image
              //     src={profileDetail?.user?.image ?? Images.ProfileImage}
              //     className="bg-none rounded-full"
              //     preview={false}
              //     height={70}
              //     width={100}
              //   />
              // }
              className="border-none bg-[#ba7d13]"
            />
          </div>

          <div className="w-full h-12 gap-4 text-white  text-base text-center custome">
            <p>{profileDetail?.user?.name}</p>
            <p>{profileDetail?.user?.mobile}</p>
          </div>
        </div>
        {items.map((item) => (
          <li key={item.key} className="text-white ">
            <div
              className="flex items-center justify-between cursor-pointer hover:text-yellow-400"
              onClick={item.onClick}
            >
              <span className="flex items-center gap-2 mt-6 font-thin custome">
                {item.icon && <span className="text-lg">{item.icon}</span>}
                {item.label}
              </span>
              {item.children && (
                <span className="text-gray-400 text-sm">▶</span>
              )}
            </div>

            {item.children && (
              <div className="ml-4 border-l border-gray-600 pl-2">
                {renderMenuItems(item.children)}
              </div>
            )}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <>
      {showSidebar && (
        <div
          className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-10 z-40"
          onClick={() => setShowSidebar(false)}
        />
      )}

      {showSidebar && (
        <div
          className={`fixed top-0 left-100 h-full w-64 bg-[#1f1f1f] z-50 p-4 transform transition-transform duration-300 ${showSidebar ? "translate-x-0" : "-translate-x-full"
            }`}
        >
          <div className="flex justify-end mb-4">
            <button onClick={() => setShowSidebar(false)}>
              <IoClose className="text-white w-6 h-6" />
            </button>
          </div>

          <div className="overflow-y-auto h-[calc(100%-60px)] pr-2">
            {renderMenuItems(menuItems)}

            <hr className="my-4 border-gray-600" />

            <ul className="space-y-4 text-white text-base text-center">
              <Button
                type="default"
                className="sm:mt-32 custome rounded-3xl h-10 font-medium text-lg border-none
                   text-white bg-gradient-to-r from-[#734e0c] via-[#ba7d13] to-[#e9a52f]
                   hover:bg-gradient-to-r hover:from-[#734e0c] hover:via-[#ba7d13] hover:to-[#e9a52f]"
                onClick={() => {
                  localStorage.clear();
                  navigate("/");
                }}
              >
                LogOut
              </Button>
            </ul>
          </div>
        </div>
      )}

      <div className="flex justify-center pb-20 items-center bg-black rounded-lg">
        <div className="w-full">
          <div className="flex justify-between bg-gradient-to-r from-[#734e0c] via-[#ba7d13] to-[#fba037] px-8 py-2 gap-x-3 items-center">
            <div className="text-white font-semibold flex items-center gap-4">
              {accessToken && (
                <IoMenu
                  className="bg-[#ba7d13] h-7 w-7 rounded-lg cursor-pointer text-white"
                  onClick={() => setShowSidebar(true)}
                />
              )}
              <p className="text-xl font-normal custome">Chandni Chowk Matka</p>
            </div>
            <div
              className="flex justify-between items-center cursor-pointer"
              onClick={() => navigate("/wallet")}
            >
              <img src={Images.Money} className="w-8 m-auto my-2" alt="money" />
              <p className="text-white text-sm custome">
                ₹ {profileDetail?.user?.wallet_balance ?? 0}
              </p>
            </div>
          </div>

          <div className="h-[100vh] bg-black overflow-scroll">
            {" "}
            <div className=" m-2 rounded-lg">
              <Card className="bg-black shadow-md border-none shadow-gray-500">
                <div className="flex justify-between items-center">
                  <Card.Meta
                    className="text-white"
                    title={
                      <>
                        <p className="custome text-white">
                          Play Matka on Chandni Chowk Matka app
                        </p>
                      </>
                    }
                    description={
                      <>
                        <p className="custome text-white">
                          Play Matka on Chandni Chowk Matka app and enjoy our services
                        </p>
                      </>
                    }
                  />
                  {/* <div>
                    <a href="tel:+911234567890">
                      {" "}
                      <Button
                        className="rounded-full custome border-none bg-gradient-to-r from-[#c86d04] via-[#ba7d13] to-[#fba037]
                   hover:bg-gradient-to-r hover:from-[#ba7d13] hover:via-[#fba037] hover:to-[#c86d04] text-white"
                      >
                        Call
                      </Button>
                    </a>
                  </div> */}
                </div>
              </Card>
            </div>
            <div className="rounded-lg grid grid-cols-1 gap-2">
              {/* Chandni Chowk Matka */}
              <div
                className="bg-black shadow-md shadow-gray-500 cursor-pointer rounded-md p-2"
                onClick={() => navigate("/home")}
              >
                <div className="text-white text-center">
                  <Image
                    preview={false}
                    height={150}
                    src={Images.Logo}
                    alt="jetXmatka"
                    className="rounded-md mx-auto w-full"
                  />
                </div>
                <div className="flex justify-center mt-2">
                  <Button
                    className="rounded-full custome border-none bg-gradient-to-r from-[#c86d04] via-[#ba7d13] to-[#fba037]
          hover:bg-gradient-to-r hover:from-[#ba7d13] hover:via-[#fba037] hover:to-[#c86d04] text-white"
                  >
                    Chandni Chowk Matka
                  </Button>
                </div>
              </div>

              {/* Aviator */}
              <div
                className="bg-black shadow-md shadow-gray-500 cursor-pointer rounded-md p-2"
                onClick={() => navigate("/lottery/aviator")}
              >
                <div className="text-white text-center">
                  <Image
                    preview={false}
                    // width={96}
                    height={150}
                    src={Images.a1}
                    alt="aviator"
                    className="rounded-md mx-auto w-full"
                  />
                </div>
                <div className="flex justify-center mt-2">
                  <Button
                    className="rounded-full custome border-none bg-gradient-to-r from-[#c86d04] via-[#ba7d13] to-[#fba037]
          hover:bg-gradient-to-r hover:from-[#ba7d13] hover:via-[#fba037] hover:to-[#c86d04] text-white"
                  >
                    Aviator
                  </Button>
                </div>
              </div>

              {/* Mines */}
              <div
                className="bg-black shadow-md shadow-gray-500 cursor-pointer rounded-md p-2"
                onClick={() => navigate("/mini-games/mines")}
              >
                <div className="text-white text-center">
                  <Image
                    preview={false}
                    height={150}
                    src={Images.mines2}
                    alt="mines"
                    className="rounded-md mx-auto w-full"
                  />
                </div>
                <div className="flex justify-center mt-2">
                  <Button
                    className="rounded-full custome border-none bg-gradient-to-r from-[#c86d04] via-[#ba7d13] to-[#fba037]
          hover:bg-gradient-to-r hover:from-[#ba7d13] hover:via-[#fba037] hover:to-[#c86d04] text-white"
                  >
                    Mines
                  </Button>
                </div>
              </div>

              {/* Plinko */}
              <div
                className="bg-black shadow-md shadow-gray-500 cursor-pointer rounded-md p-2"
                onClick={() => navigate("/mini-games/plinko")}
              >
                <div className="text-white text-center">
                  <Image
                    preview={false}
                    height={150}
                    src={Images.plinko1}
                    alt="plinko"
                    className="rounded-md mx-auto w-full"
                  />
                </div>
                <div className="flex justify-center mt-2">
                  <Button
                    className="rounded-full custome border-none bg-gradient-to-r from-[#c86d04] via-[#ba7d13] to-[#fba037]
          hover:bg-gradient-to-r hover:from-[#ba7d13] hover:via-[#fba037] hover:to-[#c86d04] text-white"
                  >
                    Plinko
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllGame;
